import PropTypes from 'prop-types'
import React from "react"
import { Link } from "react-router-dom"
import { isEmpty, isEqual, map , isNull} from "lodash"
import {
  Card,
  CardBody,
  Col,
  Media,
} from "reactstrap"
import logoLightPng from "../../assets/images/birthchartlogo.png"
import * as moment from 'moment'
import { getUserRole } from "components/Common/Roles"


const CardProject = ({ birthChartList, handleDownload }) => {
  const birth_card_strong_style = {
    fontFamily: "Helvetica Neue,Helvetica,Arial,sans-serif",
    boxSizing: "border-box",
    fontSize: "14px",
    margin: "0",
  }
  const birth_card_span_style = {
    backgroundColor: "#20c5c9",
    color: "#ffffff",
    padding: "3px 5px",
    fontSize: "12px",
    borderRadius: "4px",
  }

  const birth_card_pay_now_style = {
    backgroundColor: "#dfb53d",
    color: "#ffffff",
    padding: "3px 5px",
    fontSize: "12px",
    borderRadius: "4px",
  }

  

  const birth_card_span_style_payment = {
    backgroundColor: "#faae7bc4",
    color: "#ffffff",
    padding: "3px 5px 5px",
    fontSize: "12px",
    borderRadius: "4px",
    margin: "0px 0px 0px 20px",

  }

  const birth_card_span_style_trial_payment = {
    backgroundColor: "#cccccc",
    color: "#ffffff",
    padding: "3px 5px",
    fontSize: "12px",
    borderRadius: "4px",
  }

  const birth_card_span_style_disabled = {
    backgroundColor: "#acacb6",
    color: "#ffffff",
    padding: "3px 5px",
    fontSize: "12px",
    borderRadius: "4px",
  }

const avatar_title_10 = {
  backgroundColor: '"#acacb6"',

  }
  console.log(birthChartList)
  let userRoles = getUserRole()
  let showDisabled = true;
  let styleclass = '';
  
   const calculateAge = (dob) => {
  const birthDate = new Date(dob);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const monthDifference = today.getMonth() - birthDate.getMonth();

  if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
let colorCode = "#112233";
if (age <= 10) {
  colorCode = "#445566";
} else if (age >=11 && age <=21) {
  colorCode = "#778899";
}else if (age >=22 && age <60) {
  colorCode = "#001122";
} else {
  colorCode = "#334455";
}

  return colorCode;
};


const getButtonStyle = (paymentStatus) => {
  let style;
  if (paymentStatus === 'PAID') {
      style = birth_card_span_style;
  } else if (paymentStatus === 'PENDING') {
      //style = birthCardSpanStylePending;
  } else {
      style = birth_card_span_style_trial_payment;
  }
  return style;
}

  return (
    <React.Fragment>
      {map(birthChartList, (birthChart, dkey) => (
        <Col xl="6" sm="6" key={"__projectcd_" + dkey}>
          <Card>
            <CardBody>
              <Media>
                <div className="avatar-md me-4">
                <span
                      className= "avatar-user-title rounded-circle  font-size-18 "
                    >
                     {isEmpty(birthChart.name) ? (birthChart.firstName.charAt(0) + " " + birthChart.lastName.charAt(0)) : (birthChart.name.charAt(0).toUpperCase())}
                    </span>
                </div>

                <Media className="overflow-hidden" body>
                  <h5 className="text-truncate font-size-15">
                    <Link
                      //to={`/birthchart-detail/${birthChart.id}`}
                      //to={`/users-birthchart/${birthChart.id}`}
                      to = {`/birthchart-report`}
                      className={!isEqual("PAID", birthChart.paymentStatus) ? ("disabled-link text-muted") : ("text-dark")}
                    >
                      {isEmpty(birthChart.name) ? (birthChart.firstName + " " + birthChart.lastName) : (birthChart.name)}
                      {/* {isEmpty(birthChart.name) ? (() => {
                        isEmpty(birthChart.lastName) ? (birthChart.firstName)
                          : (birthChart.firstName + " " + birthChart.lastName)
                      }) : (birthChart.name)} */}
                    </Link>
                  </h5>

                  <ul className="text-muted list-inline mb-2">
                    <li className="list-inline-item me-0" id="dueDate">
                      <i className="bx bx-cake me-0" /> {birthChart.dateOfBirth}
                    </li>{" "}
                    <li className="list-inline-item me-0" id="comments">
                      <i className="bx bx-time me-0" />{" "}
                      {birthChart.timeOfBirth}
                      
                    </li>
                  </ul>

                  <h5 className="text-truncate font-size-15 text-success mb-2">
                    Gender : {birthChart.gender} , Birth Type : {birthChart.birthType}
                  </h5>
                  
                  {/* <p className="mb-1">
                    <i className="bx bx-calendar me-1" />
                    {moment(new Date(birthChart.createdDate)).format("MM-DD-YYYY hh:mm:ss a")}
                  </p> */}
                </Media>
              </Media>
            </CardBody>
            {showDisabled = true }

            <div className="px-3 py-3 border-top">
              <ul className="list-inline mb-0">
                <li className="text-muted list-inline-item me-3" id="createdDate">
                  <i className="bx bx-calendar me-1" />{moment(new Date(birthChart.createdDate)).format("DD-MM-YYYY hh:mm:ss a")}
                 
                </li>
                
                {/* <li className="list-inline-item me-2" id="view">
                  <Link to={`/users-birthchart/${birthChart.id}`} className={() => {
                    if (isEqual("PAID", birthChart.paymentStatus)) {
                      return ""
                    } else {
                      return "disabled-link"
                    }
                  }}>
                    <strong style={birth_card_strong_style}>
                      <span style={birth_card_span_style}>
                        View
                      </span>
                    </strong>
                  </Link>
                </li> */}
                
                
                {userRoles.user && (
                  <li className="list-inline-item me-3" id="view">
                  <Link to={`/users-birthchart/${birthChart.id}`} 
                  className={!isEqual("PAID", birthChart.paymentStatus) ? (" disabled-link text-muted") : ("")}>
                    <strong style={birth_card_strong_style}>
                      <span style={getButtonStyle(birthChart.paymentStatus)}>
                      View
                      </span>
                    </strong>
                  </Link>
                  </li>
                  )}
                  {userRoles.user && (
                  <li className="list-inline-item me-0 text-muted" id="download">
                  <Link to="#" onClick={() => {
                    handleDownload(birthChart.id, birthChart.name)
                  }} className={!isEqual("PAID", birthChart.paymentStatus) ? (" disabled-link text-muted") : ("")}>
                    
                    <strong style={birth_card_strong_style}>
                      <span  style={getButtonStyle(birthChart.paymentStatus)}>
                      Download
                      </span>
                    </strong>
                  </Link>
                  </li>
                  )}
                  {userRoles.productAdmin && (
                  <li className="list-inline-item me-2" id="view">
                  <Link to={`/users-birthchart/${birthChart.id}`} >
                    <strong style={birth_card_strong_style}>
                      <span style={birth_card_span_style}>
                      View 
                      </span>
                    </strong>
                  </Link>
                  </li>
                  )}
                  {userRoles.productAdmin && (
                  <li className="list-inline-item me-0 text-muted" id="download">
                  <Link to="#" onClick={() => {
                    handleDownload(birthChart.id, birthChart.name)
                  }} >
                    <strong style={birth_card_strong_style}>
                      <span style= {birth_card_span_style }>
                      Download
                      </span>
                    </strong>
                  </Link>
                  </li>

                  )}
                  {userRoles.productAdmin && !isEqual("PAID", birthChart.paymentStatus) && (
                  <li className="list-inline-item me-0 text-muted" id="download">
                 
                    <strong style={birth_card_strong_style}>
                      <span style= {birth_card_span_style_payment }>
                    Not Paid
                      </span>
                    </strong>
                 
                  </li>

                  )}
                
                {!showDisabled && (
                  <li className="list-inline-item me-2 " id="pendingPayment">
                    <Link to="#" className="disabled-link">
                    <strong style={birth_card_strong_style}>
                      <span style={birth_card_span_style}>
                      PAID                       
                      </span>
                    </strong>

                    </Link>
                  </li>
                )}
                {userRoles.user && !isNull(birthChart.rePaymentUrl) && (
                  <li className="list-inline-item me-0 " id="pendingPayment">
                    <a href={birthChart.rePaymentUrl } >
                      <strong style={birth_card_strong_style}>
                        <span style={birth_card_pay_now_style}>
                         {"  "} Pay Now
                      </span>
                      </strong>
                    </a>
                  </li>
                )}
                {isEqual("TRIAL", birthChart.paymentStatus) && (
                  <li className="list-inline-item me-0 float-end" id="pendingPayment">
                    <Link to="#" className="disabled-link">
                      <strong style={birth_card_strong_style}>
                        <span style={birth_card_span_style_trial_payment}>
                        complimentary
                      </span>
                      </strong>
                    </Link>
                  </li>
                )}
              </ul>
            </div>
          </Card>
        </Col>
      ))
      }
    </React.Fragment >
  )
}

CardProject.propTypes = {
  birthChartList: PropTypes.array
}

export default CardProject